import { render, staticRenderFns } from "./EduForm.vue?vue&type=template&id=418e5220"
import script from "./EduForm.vue?vue&type=script&lang=js"
export * from "./EduForm.vue?vue&type=script&lang=js"
import style0 from "./EduForm.vue?vue&type=style&index=0&id=418e5220&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports